
export const getToken = () => {
    return JSON.parse(localStorage.getItem("context"))["token"];
}

export const setContext = (data) => {
    localStorage.setItem('context', JSON.stringify(data));
}

export const clearContext = () => {
    localStorage.removeItem('context');
}

export const setSlots = (data) => {
    localStorage.setItem("slots", JSON.stringify(data));
}

export const getSlots = () => {
    return JSON.parse(localStorage.getItem("slots"));
}